import { gql } from '@apollo/client';

import type * as GraphQLTypes from '../../../graphql/types.generated';
export type UpdateAccountLocationDetailsMutationVariables = GraphQLTypes.Exact<{
  input: GraphQLTypes.UpdateAccountLocationDetailsInput;
}>;

export type UpdateAccountLocationDetailsMutationResult = { __typename?: 'Mutation' } & {
  updateAccountLocationDetails?: GraphQLTypes.Maybe<
    { __typename?: 'UpdateAccountLocationDetailsPayload' } & {
      errors?: GraphQLTypes.Maybe<Array<{ __typename?: 'Error' } & Pick<GraphQLTypes.Error, 'message' | 'path'>>>;
    }
  >;
};

export const UpdateAccountLocationDetailsDocument = gql`
  mutation updateAccountLocationDetails($input: UpdateAccountLocationDetailsInput!) {
    updateAccountLocationDetails(input: $input) {
      errors {
        message
        path
      }
    }
  }
`;
